import { render, staticRenderFns } from "./question-01.vue?vue&type=template&id=0d2c7a76&scoped=true&lang=pug"
var script = {}
import style0 from "./question-01.vue?vue&type=style&index=0&id=0d2c7a76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c7a76",
  null
  
)

export default component.exports